import { useQuery } from '@tanstack/react-query';

import { accountsClient } from 'services/connectivity/accounts/client';
import { Account } from 'services/connectivity/accounts/types';
import { getAccessToken } from 'helpers/account';
import { errorDeserialize } from 'helpers/error-deserializer';

const DEFAULT_VALUE: Account[] = [];

interface IUseGetMe {
  accounts: Account[];
  isFetching: boolean;
}

export const fetchAccounts = async (token: string): Promise<Account[]> => {
  const { result, error } = await accountsClient.list(token);

  if (error) {
    throw errorDeserialize(error);
  }

  return result;
};

export const useAccounts = (): IUseGetMe => {
  const { data: accounts, isFetching } = useQuery<Account[], string>(
    ['get-accounts'],
    () => fetchAccounts(getAccessToken()),
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
      retry: 1,
    }
  );
  return {
    accounts: accounts ?? DEFAULT_VALUE,
    isFetching,
  };
};
